import React from 'react';
import PremiumImage from 'assets/images/dashboard/icon-premium.png';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { SET_MODAL_STATUS } from 'store/actions';

const PremiumSuccess = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const userDataParse = localStorage.getItem('diologUserData') ? JSON.parse(localStorage.getItem('diologUserData')) : {};
    return (
        <Box className="modal-inner-wrap">
            <Box className="modal-hero">
                <img src={PremiumImage} alt="Premium" width="150" height="150" />
            </Box>
            <Box className="modal-body">
                <Typography variant="h2" component="h2">
                    You’ve supercharged your subscription plan!
                </Typography>
                <Typography variant="body1" component="p">
                    Welcome to Diolog Premium! You now have unlimited team capacity and access to premium Diolog features such as the
                    question registry, real-time investor sentiment score, advanced investor question workflows, and more.
                </Typography>
            </Box>
            <Box className="modal-footer pt-0">
                <Button
                    variant="contained"
                    onClick={() => {
                        navigate('/dashboard');
                        dispatch({ type: SET_MODAL_STATUS, modalStatus: false });
                    }}
                    style={{ borderRadius: '12px' }}
                >
                    Got it!
                </Button>
            </Box>
        </Box>
    );
};

export default PremiumSuccess;
